import zhLocale from 'element-ui/lib/locale/lang/ja'
import home from './ja/home'

const ja = {
    language: '日本語',
    message: {
        'home': {
            ...home,
            enterEmail: 'メールアドレスを入力してください',
            save: '保存',
            saveSuccess: '保存に成功しました',
            pointHistory: 'ポイント履歴',
            type: 'タイプ',
            remark: '備考',
            pendingComment: '未評価',
            commented: '評価済み',
            selectDate: '日付を選択',
            loginSuccess: 'ログインに成功しました',
            loginFail: 'ログインに失敗しました',
            close: '閉じる',
            required: '必須',
            nickname: 'ニックネーム',
            enterNickname: 'ニックネームを入力してください',
            gender: '性別',
            male: '男性',
            female: '女性',
            secret: '非公開',
            birthday: '誕生日',
            checkoutLoadFailed: '決済情報の読み込みに失敗しました。しばらくしてから再度お試しください。',
            checkoutErrorTitle: 'お知らせ',
            goAddAddress: 'お届け先住所を追加',
            shop_order_selectOrAddAddress: '先にお届け先住所を追加し、既定に設定してから精算してください。',
            shop_order_cartEmpty: 'カートが空のため、精算できません。',
            shop_order_cartHasNotActive: '未公開または無効な商品があるため、精算できません。',
            shop_order_cartHasNotMarketable: '販売停止の商品があるため、精算できません。',
            shop_order_cartHasLowStock: '在庫が不足しているため、精算できません。',
            shop_order_cartHasExpiredGoods: '一部の店舗商品が期限切れのため、精算できません。',
            shop_order_typeIsNull: '注文タイプを認識できません。商品タイプをご確認ください。',
            shop_order_goodsNotFound: '商品情報が存在しないか、削除されています。',
            shop_order_giftNotForSale: 'ギフト商品は直接購入できません。',
            common_message_badRequest: '無効なリクエストです。商品とパラメータをご確認ください。',
        },
    },
    '手机号码最小长度为8位': "携帯電話番号の最小長は 8 桁です。",
    '邮箱账号名称最小长度为6位': "電子メール アカウント名の最小長は 6 文字です。",
    '邮箱只能包含英文，数字等字符': "メールボックスには英語や数字などの文字のみを含めることができます",
    '请选择正确的收货地址': '正しい配送先住所を選択してください',
    Dict_language_status_0: '無効',
    Dict_language_status_1: '有効',
    Dict_member_label_type_1: '条件タグ',
    Dict_member_label_type_2: '手動タグ',
    Dict_member_level_type_0: '消費レベル（LV）',
    Dict_member_level_type_1: '有料会員（VIP）',
    Dict_member_growth_action_type_1: '注文する',
    Dict_member_growth_action_type_2: '毎日ログイン',
    Dict_member_growth_action_type_3: 'レビュー投稿',
    Dict_member_growth_action_type_4: 'プロフィール入力',
    Dict_paid_member_payment_type_0: '残高支払い',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: '有効',
    Dict_paid_member_record_status_1: '期限切れ',
    Dict_paid_member_record_status_2: '返金済み',
    Dict_point_lottery_prize_type_0: 'ポイント',
    Dict_point_lottery_prize_type_1: 'クーポン',
    Dict_point_lottery_prize_type_2: '実物賞品',
    Dict_point_lottery_prize_type_3: 'ご参加ありがとうございます',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'メール',
    Dict_notification_channel_type_2: 'サイト内メッセージ',
    Dict_notification_channel_type_3: 'プッシュ通知',
    Dict_announcement_status_0: '下書き',
    Dict_announcement_status_1: '公開済み',
    Dict_announcement_status_2: '公開停止',
    Dict_live_permission_status_0: '未申請',
    Dict_live_permission_status_1: '審査中',
    Dict_live_permission_status_2: '開通済み',
    Dict_live_permission_status_3: '却下',
    Dict_live_room_status_0: '未開始',
    Dict_live_room_status_1: '配信中',
    Dict_live_room_status_2: '終了',
    Dict_live_room_status_3: '異常中断',
    Dict_live_room_type_0: 'プラットフォーム配信',
    Dict_live_room_type_1: '店舗配信',
    Dict_store_type_0: '個人店',
    Dict_store_type_1: '企業店',
    Dict_store_sign_status_0: '契約待ち',
    Dict_store_sign_status_1: '契約済み',
    Dict_store_sign_status_2: '解約',
    Dict_store_business_change_status_0: '審査待ち',
    Dict_store_business_change_status_1: '審査通過',
    Dict_store_business_change_status_2: '審査却下',
    Dict_decoration_page_type_0: 'ホーム',
    Dict_decoration_page_type_1: 'カテゴリページ',
    Dict_decoration_page_type_2: 'キャンペーンページ',
    Dict_decoration_page_type_3: 'カスタムページ',
    Dict_decoration_status_0: '下書き',
    Dict_decoration_status_1: '公開済み',
    Dict_decoration_popup_trigger_page_0: 'プラットフォームホーム',
    Dict_decoration_popup_trigger_page_1: '会員センター',
    Dict_decoration_popup_trigger_page_2: '支払い成功',
    Dict_decoration_popup_target_user_0: '全ユーザー',
    Dict_decoration_popup_target_user_1: '無料会員',
    Dict_decoration_popup_target_user_2: '有料会員',
    Dict_decoration_popup_frequency_0: '永久に1回',
    Dict_decoration_popup_frequency_1: '毎回表示',
    Dict_decoration_popup_frequency_2: 'カスタム頻度',
    Dict_track_event_type_page_view: 'ページビュー',
    Dict_track_event_type_click: 'クリック',
    Dict_track_event_type_add_to_cart: 'カートに追加',
    Dict_track_event_type_search: '検索',
    Dict_track_event_type_purchase: '購入',
    Dict_track_event_type_live_watch: 'ライブ視聴',
    Dict_reconcile_period_type_0: '日次',
    Dict_reconcile_period_type_1: '週次',
    Dict_reconcile_period_type_2: '月次',
    Dict_store_settlement_status_0: '精算待ち',
    Dict_store_settlement_status_1: '精算済み',
    Dict_distributor_status_0: '審査待ち',
    Dict_distributor_status_1: '審査済み',
    Dict_distributor_status_2: '却下',
    Dict_distribution_commission_type_0: '直接コミッション',
    Dict_distribution_commission_type_1: '間接コミッション',
    Dict_configuration_status_0: '無効',
    Dict_configuration_status_1: '有効',
    ...zhLocale
}

export default ja
